import { isNil } from 'lodash-es';
import { useContext } from 'react';

import { CookieBannerContext } from './CookieBannerProvider';

const useCookieBanner = () => {
  const ctx = useContext(CookieBannerContext);

  if (isNil(ctx)) {
    throw new Error('useCookieBanner must be used within a CookieBannerProvider!');
  }

  return ctx;
};

export default useCookieBanner;
